<div class="subject-card__list tw:flex-1 tw:px-[15px] tw:flex tw:flex-wrap">
  @for (subject of subjects; track subject) {
    <div class="card subject-card" (click)="openTimeline(subject)">
      <!-- todo: Find out why regex not working -->
      <!-- <img class="subject-card__img" src="../../../assets/img/subject-banner-{{subject.toLowerCase().replace(/\s/g, '-')}}-v2.png"> -->
      <div class="subject-card__frame">
        <img class="subject-card__img" src="../../../assets/img/subject-banner-{{subject.toLowerCase().replace(' ', '-').replace(' ', '-')}}-v2.png">
        <img class="subject-card__img subject-card__img--overlay" src="../../../assets/img/subject-banner-{{subject.toLowerCase().replace(' ', '-').replace(' ', '-')}}-v2.png">
      </div>
      <div class="back-arrow-icon-container"
        data-toggle="tooltip" data-placement="top" title="Open Timeline for subject">
        <div class="back-arrow-icon cursor-pointer"></div>
      </div>
      <div class="subject-card__body">
        <h4 class="subject-card__title tw:m-6">{{subject}}</h4>
      </div>
    </div>
  }
</div>
